import { getLogger } from '@/idv2/utils/logger';

const { logWarn } = getLogger({ name: 'idv2', location: 'identify' });

// Legacy identify logs the same message, so one search compares handled errors on both engines.
export const logIdentifyError = (step: string, error: unknown) =>
  logWarn(`Error in ${step}:`, error, { engine: 'idv2' });
